export default __webpack_public_path__ + "static/media/coffeeBike.e975c6dd.png";